import React from 'react';
import successIcon from 'assets/img/icons/check_circle.svg';
import errorIcon from 'assets/img/icons/report.svg';

export const AlertVariantType = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

function Alert({ variant, text }) {
  const img = {
    SUCCESS: successIcon,
    ERROR: errorIcon,
  };
  return (
    <div
      className={`new-alert ${variant === AlertVariantType.SUCCESS && 'new-alert--success'} ${variant === AlertVariantType.ERROR && 'new-alert--error'}`}
    >
      <img className="new-alert__img" src={img?.[variant]} alt="Icon" />
      <span className="new-alert__text">{text}</span>
    </div>
  );
}

export default Alert;
